import { isDevelopment, isInExtension } from '~/helpers/utils';

/**
 * Saves something to the storage
 * @param {string} key
 * @param {any} value
 * @param {sync | local} chromeStorageType Default: sync
 */
export async function saveToStorage(
    key: string,
    value: any,
    chromeStorageType: 'sync' | 'local' = 'sync'
): Promise<void> {
    if (isInExtension()) {
        await chrome.storage[chromeStorageType].set({
            [key]: JSON.stringify(value),
        });
    } else {
        localStorage[key] = JSON.stringify(value);
    }
}

/**
 * @param key
 * @param {sync | local} chromeStorageType Default: sync
 * @returns NOTE: returns object already
 */
export async function getFromStorage(
    key: string,
    chromeStorageType: 'sync' | 'local' = 'sync'
): Promise<any> {
    let storedValue, result;
    if (isInExtension()) {
        const data = await chrome.storage[chromeStorageType].get({
            [key]: null,
        });
        if (isDevelopment()) {
            console.log(
                `[DEV] get from chrome.storage.${chromeStorageType}[${key}]`
            );
        }
        storedValue = data[key];
    } else {
        if (isDevelopment()) {
            console.log(`[DEV] get from localStorage[${key}]`);
        }
        storedValue = localStorage[key] || null;
    }
    try {
        result = JSON.parse(storedValue);
    } catch (e) {
        console.log('getLocalStorage - error parsing JSON: ', e);
        result = storedValue;
    }
    return result;
}
